import { type ReactNode, useState } from 'react';
import { CreatorDetailModal } from '@/modules/creators';
import { useAuth } from '@/hooks/use-auth';
import { usePipelineConfig } from '@/hooks/use-pipeline-config';
import { PipelineFilters } from './pipeline-filters';
import { KanbanBoard } from './kanban-board';
import {
  PipelineLoading,
  PipelineRedirect,
  shouldRedirect,
} from './pipeline-guards';

export function PipelinePage(): ReactNode {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { enabled, isLoading } = usePipelineConfig();
  const { isAdmin, user } = useAuth();
  const guard = shouldRedirect({
    isLoading,
    isCollector: user?.role === 'collector',
    enabled,
    isAdmin,
  });

  if (guard === 'loading') return <PipelineLoading />;
  if (guard === 'redirect') return <PipelineRedirect />;

  return (
    <div className="flex h-[calc(100dvh-80px)] flex-col gap-lg">
      <PipelineFilters />
      <div className="min-h-0 flex-1">
        <KanbanBoard onSelect={setSelectedId} />
      </div>
      <CreatorDetailModal
        leadId={selectedId}
        onClose={() => setSelectedId(null)}
      />
    </div>
  );
}
